import Card from "../Reusable/Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

export default function Cards() {
  const data = [
    {
      name: "Total Fleet Size",
      count: 10,
    },
    {
      name: "Active Vehicles",
      count: 10,
    },
    {
      name: "Idle Vehicles",
      count: 10,
    },
    {
      name: "Average Fuel Efficiency",
      count: 10,
    },
    {
      name: "Driver Availability",
      count: 10,
    },
  ];
  return (
    <div className={tw`grid grid-cols-5 gap-4`}>
      {data.map((d, i) => (
        <Card key={i} title={d.name}>
          <p>{d.count}</p>
        </Card>
      ))}
    </div>
  );
}
